import { useState } from 'react'
import { LogIn, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent } from '@/components/ui/card'
import { useAuth } from '@/context/AuthContext'

export function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await signIn(email.trim(), password)
      // O AuthProvider troca a rota sozinho ao receber a sessão.
    } catch (err) {
      const msg = (err as Error).message
      // Não revelamos se o e-mail existe: mensagem única para credencial inválida.
      setError(/invalid login/i.test(msg) ? 'E-mail ou senha inválidos.' : msg)
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-svh items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardContent className="p-6">
          <div className="mb-6 flex items-center gap-2">
            <div className="bg-primary text-primary-foreground flex size-9 items-center justify-center rounded-lg font-bold">
              €
            </div>
            <div>
              <div className="leading-tight font-semibold">EasyMoney</div>
              <div className="text-muted-foreground text-xs">Entre para continuar</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                autoComplete="username"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <p className="border-destructive/40 bg-destructive/10 text-destructive rounded-md border p-2 text-sm">
                {error}
              </p>
            )}

            <Button type="submit" disabled={busy}>
              {busy ? <Loader2 className="size-4 animate-spin" /> : <LogIn className="size-4" />}
              {busy ? 'Entrando…' : 'Entrar'}
            </Button>
          </form>

          <p className="text-muted-foreground mt-4 text-center text-xs">A sessão expira em 24 horas.</p>
        </CardContent>
      </Card>
    </div>
  )
}
